<div class="modal-header">
  <h5 class="modal-title">Take Case Off Hold</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off" [formGroup]="offHoldDetails">

    <div class="mb-3">
      <label class="form-label">Off Hold Reason</label>
      <textarea class="form-control" 
                #offHoldReason
                formControlName="offHoldReason" 
                placeholder="Off Hold Reason"
                maxlength="200"
                rows="4"></textarea>
      <div class="form-text text-end">{{offHoldReason.value?.length || 0}}/200</div>
    </div>

  </form>
</div>

<div class="modal-footer">

  <button *ngIf="!isLoading" 
          type="button" 
          class="btn btn-success" 
          (click)="takeCaseOffHold()"
          [disabled]="offHoldReason.value?.length == 0">
    OK
  </button>

  <button *ngIf="isLoading" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Saving...
  </button>
</div>